module.exports = __webpack_public_path__ + "media/images/emblems/Wolfwil-blason-9a7cd43a7958cc5e885cd30894499636.png";